import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { useRelevancyConfig } from '../../hooks/use-relevancy-config';
import * as Styled from './styles';
import * as SX from './sx';
import type { RelevancySummaryPopupHeaderProps as Props } from './types';

export const RelevancySummaryPopupHeader = memo(
  ({ className, relevancy }: Props) => {
    const relevancyData = useRelevancyConfig(relevancy);

    if (!relevancyData) {
      return null;
    }

    return (
      <Styled.Wrapper
        className={classnames('RelevancySummaryPopupHeader', className)}
        sx={{
          ...SX.root,
          backgroundColor: `${relevancyData.color}.50`,
        }}
      >
        <Typography
          variant="body3"
          fontWeight={700}
          color={`${relevancyData.color}.700`}
        >
          {relevancyData.score.toFixed(2)} %
        </Typography>
        <Typography
          variant="body3"
          fontWeight={400}
          color={`${relevancyData.color}.700`}
        >
          {relevancyData.config.title}
        </Typography>
      </Styled.Wrapper>
    );
  }
);

RelevancySummaryPopupHeader.displayName = 'RelevancySummaryPopupHeader';
